import React, { useEffect, useState } from 'react';
import { Container, Row, ProgressBar } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import ReviewCard from './common/ReviewCard';
import api from '../seller-apis/api';
import { fetchReviewsData } from '../seller-apis/apidataField';
import PaginationCom from './common/Pagination';
import './review.css';
import Header from './common/Header';


function Review() {

  let history = useHistory();
  // Size states

  const [currView, setcurrView] = useState();

  const [reviewList, setreviewList] = useState([]);

  // Pagination related

  const [selectedPage, setSelectedPage] = useState(1);
  const [totalrecords, setTotalRecords] = useState();

  //  Loader

  const [ennewloader, setennewloader] = useState();

  useEffect(() => {
    let size = window.innerWidth;
    if (size > 768) {
      setcurrView('laptop')
    }
    else {
      setcurrView('mobile')
    }
    setennewloader("none")
    let data = {
      "pageNo": "1"
    }
    api.Reviews.fetchReviews(fetchReviewsData(data)).then(res => {
      console.log(res)
      setreviewList(res.data)
      setTotalRecords(res.totalRecords)
    }).catch(err => console.log(err))
  }, [])

  //  Control view acc to size
  function handleResize() {
    if (window.innerWidth > 700) {
      setcurrView('laptop');
    }
    else {
      setcurrView('mobile');
    }

  }


  window.addEventListener('resize', handleResize);

  // Pagination 

  function paginate(data) {
    let outerdiv = document.getElementById("outer");
    let loaderDiv = document.getElementById("enNewLoader");
    outerdiv.classList.add("div-bk");
    loaderDiv.classList.add("loader-bt");
    setennewloader("block")
    let filterData = {
      "pageNo": data.number
    }
    setSelectedPage(data.number)
    api.Reviews.fetchReviews(fetchReviewsData(filterData)).then((res) => {
      setreviewList(res.data)
      setennewloader("none")
      outerdiv.classList.remove("div-bk");
      loaderDiv.classList.remove("loader-bt");
    }).catch(err => console.log(err))
  }

  // for mobile

  if (currView === "mobile") {
    return (
      <>

        <div id="outer">
          <div className="page-bg">
            <section>
              <Container>

                <div className="py-3 my-3 back-head-nospc bg-theme text-white"><span><i className="fa fa-arrow-left mx-3" onClick={() => history.push('/home')}></i> </span><span className="f-600">Review </span></div>
                {reviewList.length > 0 && reviewList.map((item, index) => {
                  return (
                    <ReviewCard
                      id={index}
                      productName={item.product.productName}
                      review={item.review}
                      rating={item.ratings}
                      images={item.product.images}
                    />
                  )
                })}
              </Container>
            </section>
          </div>
          <div class="d-flex justify-content-center" id="enNewLoader" >
            <div class="spinner-border" role="status" style={{ "display": ennewloader }}>
              <span class="sr-only"></span>
            </div>
          </div>
          <PaginationCom
            number={totalrecords}
            paginate={paginate}
            comp="reviews"
          />
        </div>

      </>
    )
  }

  // for Desktop

  else {
    return (
      <>

        <div className="container">
          <Row>
            <div className="col-6 ">
              <Row className="rev-line ">
                <div className="col-12  mt-4">

                  <Row className="d-flex  l-n mb-0">
                    <div className="col-6">
                      <p className="rating-text f-600"> This is the space where you can see the
                        reviews customers left after purchasing
                        your products, as well as an overview of
                        your performance in Toolsvilla.  </p>
                    </div>

                    <div className="d-flex col-6">

                      <span className="sp-width">

                        <div class="progress">
                          <span class="title timer" data-from="0" data-to="" data-speed="1800">4.1</span>
                          <div class="overlay"></div>
                          <div class="left"></div>
                          <div class="right"></div>
                          <p className="fs-13 mt-4 ">Service Quantity </p>
                          <span className="detail">Detail</span>

                        </div>







                      </span>
                      <span className="sp-width1">
                        <div class="progress z-9">
                          <span class="title timer" data-from="0" data-to="" data-speed="1800">5</span>
                          <div class="overlay"></div>
                          <div class="left"></div>
                          <div class="right"></div>
                          <p className="fs-13 mt-4 mx-2">Service Quantity </p>
                          <span className="detail ">Detail</span>


                        </div>






                      </span>

                    </div>
                  </Row>


                  <h4 className="text-center  my-5 f-700"> Ratings & Reviews</h4>

                  <Row>
                    <div className="col-5 text-center">
                      <h6 className="fs-35">4.4<i className="fa fa-star fs-19 mx-1"></i></h6>
                      <p className="gry">40,405 Ratings & <br></br> 3,735 Reviews</p>
                    </div>
                    <div className="col-7">
                      <ul>
                        <li className="d-flex gry mb-20"><span className="mt-1 fs-14 d-flex text-dark">5<i className="fa fa-star m-1 text-dark fs-12"></i></span><ProgressBar now={100} className="progress-w " /><span className="mt-1 fs-14">24,726</span></li>
                        <li className="d-flex  gry  mb-20"><span className="mt-1 fs-14 d-flex text-dark">4 <i className="fa fa-star m-1 text-dark fs-12"></i></span><ProgressBar now={40} className="progress-w" /><span className="mt-1 fs-14">10,062</span></li>
                        <li className="d-flex  gry  mb-20"><span className="mt-1 fs-14 d-flex text-dark">3<i className="fa fa-star m-1 text-dark fs-12"></i></span><ProgressBar now={20} className="progress-w" /><span className="mt-1 fs-14">2691</span></li>
                        <li className="d-flex  gry  mb-20"><span className="mt-1 fs-14 d-flex text-dark">2<i className="fa fa-star m-1 text-dark fs-12"></i></span><ProgressBar now={10} className="progress-w" /><span className="mt-1 fs-14">830</span></li>
                        <li className="d-flex  gry  mb-20"><span className="mt-1 fs-14 d-flex text-dark">1<i className="fa fa-star m-1 text-dark fs-12"></i></span><ProgressBar now={5} className="progress-w" /><span className="mt-1 fs-14">2093</span></li>

                      </ul>

                    </div>
                  </Row>

                </div>

              </Row>

            </div>
            <div className="col-6 ">
              <div id="outer" className="rev-line">
                <div className="page-bg">
                  <section>
                    <Container>

                      {/* <div className="py-3 my-3 back-head-nospc bg-theme text-white"><span><i className="fa fa-arrow-left mx-3" onClick={() => history.goBack()}></i> </span><span className="f-600">Review </span></div> */}
                      {reviewList.length > 0 && reviewList.map((item, index) => {
                        return (
                          <ReviewCard
                            id={index}
                            productName={item.product.productName}
                            review={item.review}
                            rating={item.ratings}
                            images={item.product.images}
                          />
                        )
                      })}
                    </Container>
                  </section>
                </div>
                <div class="d-flex justify-content-center" id="enNewLoader" >
                  <div class="spinner-border" role="status" style={{ "display": ennewloader }}>
                    <span class="sr-only"></span>
                  </div>
                </div>
                <PaginationCom
                  number={totalrecords}
                  paginate={paginate}
                  comp="reviews"
                />
              </div></div>
          </Row>
        </div>
      </>
    )

  }

}




export default Review;